import React from 'react'
import { useResolutionPdfsList } from '../hooks/useResolutionPdfsList'

const PdfLink = props => {
  const pdfTitle = props.to ? props.to : null
  // Find PDF by its title
  const pdfs = useResolutionPdfsList()
  const link = pdfs[pdfTitle] ? pdfs[pdfTitle] : null

  // If there is no link available, just show PDF name
  if (!link) {
    return props.title ? (
      <div className={props.className}>
        {props.starticon}
        {props.title}
      </div>
    ) : null
  }

  return (
    <a {...props} href={link} title={pdfTitle}>
      {props.children}
    </a>
  )
}
export default PdfLink
